import React from "react";

const Logo = ({
    width = 32,
    height = 32,
    title = "Quran Chat Buddy logo",
    decorative = false,
}) => {
    const ariaHidden = decorative ? true : undefined;
    const ariaLabel = decorative ? undefined : title;

    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-hidden={ariaHidden}
            aria-label={ariaLabel}
            className="w-8 h-8 object-contain"
        >
            {/* Use the PNG from public folder as an <image> inside an SVG so it can be inlined as a component */}
            <image
                href="/logo.png"
                width={width}
                height={height}
                preserveAspectRatio="xMidYMid meet"
            />
        </svg>
    );
};

export default Logo;
